export default {
  ellipsis: {
    inserted: function (el, binding, vnode) {
      // console.log(el)
      el.style.overflow = 'hidden';
      el.style.textOverflow = 'ellipsis';
      el.style.whiteSpace = 'nowrap';
    }
  },
  center_by_position: {
    inserted: function (el) {
      el.style.position = 'absolute';
      el.style.left = '50%';
      el.style.top = '50%';
      el.style.transform = 'translate(-50%, -50%)';
    }
  }
}



// WEBPACK FOOTER //
// ./src/libs/directives.js